import React, { useRef } from "react";

import classnames from "classnames";

import { SubBody } from "Cobalt/BodyText";
import { Div } from "Common/HTML";

import type { FieldInputProps } from "react-final-form";
import type { StyleProps } from "Utils/styleProps";

import makeBem from "Utils/makeBem";

export interface RangeProps extends StyleProps {
  input?: FieldInputProps<number>;
  disabled?: boolean;
  min?: number;
  max?: number;
  onChange?: (_val: number) => void;
  /** Provide a utility fn to format range labels e.g. min/max as currency */
  formatLabels?: (_val: number) => string | number;
  className?: string;
  hideLabels?: boolean;
}

const bem = makeBem("CobaltRange");

export const Range: React.FC<RangeProps> = ({ className, min, max, formatLabels, input, disabled, onChange, hideLabels, ...props }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value);
    if (onChange) {
      onChange(newValue);
    }
    if (input?.onChange) {
      input.onChange(newValue);
    }
  };

  return (
    <Div {...props}>
      <input {...input} type="range" className={classnames(bem(), className)} min={min} max={max} onChange={handleChange} disabled={disabled} />
      {!hideLabels && (
        <SubBody mt={2} className={bem("Caption")} color="muted">
          <span>{formatLabels ? formatLabels(min) : min}</span>
          <span>{formatLabels ? formatLabels(max) : max}</span>
        </SubBody>
      )}
    </Div>
  );
};
